import { atom } from "recoil";
import { CompanyServiceMatchType, CompanyType } from "../../../types";

export const addLinkOrgServiceModal = atom<boolean>({
  key: "addLinkOrgServiceModal",
  default: false,
});

export const currentEditOrgService = atom<CompanyServiceMatchType | undefined>({
  key: "currentEditOrgService",
  default: undefined,
});

export const companyList = atom<CompanyType[] | undefined>({
  key: "companyList",
  default: undefined,
});

// export const companyListSelector = selector<
//   Array<{
//     companyName: string;
//     inn: string;
//   }>
// >({
//   key: "companyListSelector",
//   get: async ({ get }: { get: any }) => {
//     const companyList = get(companyListAtom)?.map((el: CompanyType) => ({
//       companyName: el.companyName,
//       inn: el.inn,
//     }));
//     return companyList;
//   },
// });
